import React, { FC } from 'react'
import AchievementList from '../components/level/AchievementList'
import PointsProgressChart from '../components/level/PointsProgressChart'
import { AchievementsHook } from '../hooks/useAchievements'

interface LevelTabProps {
	achievements: AchievementsHook
	setPointsAwarded: (id: any) => void
	handlePointsAwarded: () => void
	setLastObservedStep: (() => Promise<void>) | ((achievementId: number, step: number) => void)
	isLoading: boolean
	pointsContainerRef: React.RefObject<HTMLDivElement>
}

const LevelTab: FC<LevelTabProps> = ({
	achievements: { achievementsByType, chartData },
	setPointsAwarded,
	handlePointsAwarded,
	setLastObservedStep,
	isLoading,
	pointsContainerRef,
}) => {
	return (
		<>
			<PointsProgressChart chartData={chartData} />

			<AchievementList
				achievementsByType={achievementsByType}
				setPointsAwarded={id => {
					setPointsAwarded(id)
					handlePointsAwarded()
				}}
				setLastObservedStep={setLastObservedStep}
				isLoading={isLoading}
				pointsContainerRef={pointsContainerRef}
			/>
		</>
	)
}

export default LevelTab
